// Ficheiro gerado automaticamente a partir de companhias_aereas_ativas.csv
// Total de companhias: 44

export const airlines = [
  {
    "name": "Aeroméxico",
    "iata": "AM"
  },
  {
    "name": "Air Canada",
    "iata": "AC"
  },
  {
    "name": "Air France",
    "iata": "AF"
  },
  {
    "name": "Air New Zealand",
    "iata": "NZ"
  },
  {
    "name": "AirAsia",
    "iata": "AK"
  },
  {
    "name": "Alaska Airlines",
    "iata": "AS"
  },
  {
    "name": "American Airlines",
    "iata": "AA"
  },
  {
    "name": "ANA All Nippon Airways",
    "iata": "NH"
  },
  {
    "name": "Avianca",
    "iata": "AV"
  },
  {
    "name": "Azul Linhas Aéreas",
    "iata": "AD"
  },
  {
    "name": "British Airways",
    "iata": "BA"
  },
  {
    "name": "Cathay Pacific",
    "iata": "CX"
  },
  {
    "name": "China Eastern Airlines",
    "iata": "MU"
  },
  {
    "name": "China Southern Airlines",
    "iata": "CZ"
  },
  {
    "name": "Copa Airlines",
    "iata": "CM"
  },
  {
    "name": "Delta Air Lines",
    "iata": "DL"
  },
  {
    "name": "easyJet",
    "iata": "U2"
  },
  {
    "name": "EgyptAir",
    "iata": "MS"
  },
  {
    "name": "Emirates",
    "iata": "EK"
  },
  {
    "name": "Ethiopian Airlines",
    "iata": "ET"
  },
  {
    "name": "Etihad Airways",
    "iata": "EY"
  },
  {
    "name": "Finnair",
    "iata": "AY"
  },
  {
    "name": "GOL Linhas Aéreas",
    "iata": "G3"
  },
  {
    "name": "Iberia",
    "iata": "IB"
  },
  {
    "name": "IndiGo",
    "iata": "6E"
  },
  {
    "name": "Japan Airlines",
    "iata": "JL"
  },
  {
    "name": "JetBlue Airways",
    "iata": "B6"
  },
  {
    "name": "Kenya Airways",
    "iata": "KQ"
  },
  {
    "name": "KLM Royal Dutch Airlines",
    "iata": "KL"
  },
  {
    "name": "Korean Air",
    "iata": "KE"
  },
  {
    "name": "LATAM Airlines",
    "iata": "LA"
  },
  {
    "name": "Lufthansa",
    "iata": "LH"
  },
  {
    "name": "Qantas",
    "iata": "QF"
  },
  {
    "name": "Qatar Airways",
    "iata": "QR"
  },
  {
    "name": "Ryanair",
    "iata": "FR"
  },
  {
    "name": "SAS Scandinavian Airlines",
    "iata": "SK"
  },
  {
    "name": "Saudia",
    "iata": "SV"
  },
  {
    "name": "Singapore Airlines",
    "iata": "SQ"
  },
  {
    "name": "Southwest Airlines",
    "iata": "WN"
  },
  {
    "name": "Turkish Airlines",
    "iata": "TK"
  },
  {
    "name": "United Airlines",
    "iata": "UA"
  },
  {
    "name": "Virgin Australia",
    "iata": "VA"
  },
  {
    "name": "WestJet",
    "iata": "WS"
  },
  {
    "name": "Wizz Air",
    "iata": "W6"
  }
];
